import { Color, Mesh } from 'three';
import { disabledMeshColor } from '@/constants/colors';
import { changeAllMeshsColor } from './changeAllMeshsColor';

export const shadowAllMeshs = (meshList: Mesh[]): void => {
  changeAllMeshsColor(new Color(disabledMeshColor), meshList);
};
